import { createSystem, defaultConfig } from '@chakra-ui/react'

const baseColors = {
  blue: {
    brand: '#29AAE2',
    900: '#002846',
    800: '#1A3F5B',
    700: '#01567B',
  },
  black: '#0D1216',
  white: '#FFFFFF',
  whitegray: {
    100: 'rgba(255, 255, 255, 0.8)',
  },
  bluegray: {
    100: '#E6F0F8',
    200: '#D8E7EF',
    300: '#AECBD8',
  },
  gray: {
    100: '#EFF1F5',
    200: '#E2E8F0',
    300: '#CBD5E0',
    500: '#718096',
  },
  red: '#C53030',
  green: '#48BB78',
}

const theme = createSystem(defaultConfig, {
  theme: {
    keyframes: {
      skeletonPulse: {
        from: { width: '0%' },
        to: { width: '100%' },
      },
      fadeIn: {
        from: { opacity: 0, top: -16 },
        to: { opacity: 1, top: 0 },
      },
      beat: {
        '0%': { transform: 'scale(1)' },
        '50%': { transform: 'scale(1.1)' },
        '100%': { transform: 'scale(1)' },
      },
      draw: {
        to: { strokeDashoffset: 0 },
      },
    },
    tokens: {
      animations: {
        skeletonPulse: { value: 'skeletonPulse 4s infinite forwards' },
        beat: { value: 'beat 0.4s ease-in-out' },
        draw: { value: 'draw 2s ease forwards' },
      },
      colors: {
        ge: {
          blue: { value: baseColors.blue.brand },
          white: { value: baseColors.white },
          whitegray: { value: baseColors.whitegray[100] },
          green: { value: baseColors.green },
          red: { value: baseColors.red },
          text: {
            primary: { value: baseColors.black },
            secondary: { value: baseColors.gray[500] },
            danger: { value: baseColors.red },
            inverse: { value: baseColors.white },
          },
          background: {
            primary: { value: baseColors.gray[100] },
            secondary: { value: baseColors.gray[200] },
            dark: { value: baseColors.blue[900] },
            'dark-hover': { value: baseColors.blue[800] },
            white: { value: baseColors.white },
            light: { value: baseColors.bluegray[100] },
          },
          illustration: {
            primary: { value: baseColors.blue[700] },
            secondary: { value: baseColors.bluegray[300] },
            tertiary: { value: baseColors.bluegray[200] },
          },
          input: {
            outline: { value: baseColors.gray[300] },
          },
          button: {
            menu: {
              hover: { value: baseColors.bluegray[100] },
            },
            dark: {
              hover: { value: baseColors.blue[800] },
            },
          },
          status: {
            active: { value: baseColors.green },
            inactive: { value: baseColors.gray[500] },
          },
        },
      },
    },
  },
})

export default theme
